import React from 'react';
import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline';

const DeleteAssignmentModal = ({ isOpen, onClose, onConfirm, title, loading }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm flex items-center justify-center z-[100] p-4 animate-in fade-in duration-300">
            <div className="bg-white rounded-[2rem] shadow-2xl max-w-md w-full overflow-hidden animate-in zoom-in-95 duration-300">
                {/* Header */}
                <div className="px-8 pt-8 pb-4 flex justify-between items-start">
                    <div className="w-12 h-12 rounded-2xl bg-rose-50 flex items-center justify-center text-rose-600">
                        <ExclamationTriangleIcon className="w-6 h-6" />
                    </div>
                    <button 
                        onClick={onClose}
                        className="p-2 text-slate-300 hover:text-slate-500 rounded-xl transition-colors"
                    >
                        <XMarkIcon className="w-6 h-6" />
                    </button>
                </div>

                {/* Content */}
                <div className="px-8 pb-8">
                    <h3 className="text-xl font-black text-[#18216D] mb-2 tracking-tight">
                        Confirm Deletion
                    </h3>
                    <p className="text-sm font-medium text-slate-500 leading-relaxed">
                        Are you sure you want to delete <span className="font-bold text-[#18216D]">"{title}"</span>? 
                        This action cannot be undone and all student submissions will be permanently lost.
                    </p>
                </div>

                {/* Actions */}
                <div className="px-8 py-6 bg-slate-50 flex gap-3">
                    <button
                        onClick={onClose}
                        className="flex-1 px-6 py-4 bg-white border border-slate-200 text-slate-600 font-black text-xs uppercase tracking-widest rounded-2xl hover:bg-slate-50 transition-all active:scale-95"
                    >
                        Keep Task
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={loading}
                        className="flex-1 px-6 py-4 bg-rose-600 text-white font-black text-xs uppercase tracking-widest rounded-2xl hover:bg-rose-700 shadow-lg shadow-rose-900/20 transition-all active:scale-95 disabled:opacity-50"
                    >
                        {loading ? 'Deleting...' : 'Delete Forever'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteAssignmentModal;
